import { Box, Typography, Button } from '@mui/material';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import theme from '@monorepo/shared/src/themes/defaultTheme';

const t = (key, options?) => translate('teachingOrder', key, options);

export const SwitchOrderAlert = ({ name }) => {
  return (
    <Box>
      <Typography variant="subtitle1">
        {name} {t('nowTeachingOrder')}
      </Typography>
    </Box>
  );
};
export const SwitchOrderActionButton = ({ undoAction }) => (
  <Button style={{ marginLeft: 40, color: theme.palette.primary.main }} onClick={undoAction}>
    {t('undo')}
  </Button>
);
export const CustomCreated = ({ name }) => {
  return (
    <Box>
      <Typography variant="subtitle1" style={{ fontWeight: 'bold', fontSize: '18px' }}>
        {name} {t('createdAndInUse')}
      </Typography>
      <Typography variant="subtitle1">{t('createdSubtitle')}</Typography>
    </Box>
  );
};
export const CustomEditedAndUpdated = ({ name }) => {
  return (
    <Box>
      <Typography variant="subtitle1">{`${name}  ${t('hasBeenUpdated')}`}</Typography>
    </Box>
  );
};
export const CustomUpdated = ({ name }) => {
  return (
    <Box>
      <Typography variant="subtitle1">{`${name}  ${t('updatedAndInUse')}`}</Typography>
    </Box>
  );
};
export const CustomNameChanged = ({ name }) => {
  return (
    <Box>
      <Typography variant="subtitle1">{`${t('customNameChanged')} ${name}`}</Typography>
    </Box>
  );
};

export const Error = ({ errorMessage }) => {
  return (
    <Box>
      <Typography variant="subtitle1">{`${t(errorMessage)}`}</Typography>
    </Box>
  );
};
